import {Component} from '@angular/core';

@Component({
  selector: 'queue-node',
  templateUrl: './queue-node.component.html'
})
export class QueueNodeComponent {
    node
}
